// src/App.jsx
import React from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import MainContent from './components/layout/MainContent';
import AppRoutes from './routes';
import ErrorBoundary from './components/utils/ErrorBoundary';
import ConsentBanner from './components/ui/ConsentBanner';

function App() {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Header />
      <MainContent>
        <ErrorBoundary>
          {/* Tutaj będą renderowane komponenty stron w zależności od URL */}
          <AppRoutes />
        </ErrorBoundary>
      </MainContent>
      <Footer />
      <ConsentBanner />
    </div>
  );
}

export default App;
